import { render, staticRenderFns } from "./xisnhiTanchu.vue?vue&type=template&id=4ee7a3f0&scoped=true"
import script from "./xisnhiTanchu.vue?vue&type=script&lang=js"
export * from "./xisnhiTanchu.vue?vue&type=script&lang=js"
import style0 from "./xisnhiTanchu.vue?vue&type=style&index=0&id=4ee7a3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee7a3f0",
  null
  
)

export default component.exports